module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info widget-block"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.curList,
      "showLabels": false,
      "allowEmpty": false,
      "label": "name",
      "track-by": "id",
      "placeholder": ""
    },
    on: {
      "open": _vm.OnOpen,
      "input": _vm.OnSelect
    },
    model: {
      value: (_vm.curValue),
      callback: function($$v) {
        _vm.curValue = $$v
      },
      expression: "curValue"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-close-filter close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeFilter($event)
      }
    }
  }, [_vm._v("×")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbb7fe84"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/filterDisk.vue
// module id = 492
// module chunks = 0